<template>
  <div class="is-align-center margin-bottom-30">
    <p class="color-primary">
      Connexion
    </p>

    <h6 class="color-secondary">
      Bienvenue sur l'admin !
    </h6>
  </div>

  <form 
    @submit.prevent.stop="submit"
    inline
  >
    <f-input 
      v-model="email" 
      suffix-icon="envelope-alt"
      autofocus
      long
    ></f-input>

    <f-input 
      v-model="password"
      type="password" 
      suffix-icon="lock-alt"
      long
    ></f-input>

    <f-button 
      :disabled="loading"
      :loading="loading"
      native-type="submit"
      fill
      long
    >
      Connexion
    </f-button>

    <p 
      :class="[
        `min-h-15 is-align-center`,
        {
          'color-alert': error,
          'color-info': info,
        }
      ]"
    >
      {{ error || info }}
    </p>
  </form>

  <span></span>
</template>

<script>
  import { reactive, toRefs, nextTick } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'

  export default {
    setup () {
      const { authenticate } = useStore('@admin/auth')

      const state = reactive({
        email: '',
        password: '',
        info: '',
        error: '',
        loading: false,
      })

      async function submit () {
        state.loading = true
        state.info = 'Connexion en cours...'
        state.error = ''

        try {
          await authenticate(state.email, state.password)

          nextTick(() => {
            router.push({ name: 'home' })
          })
        } catch (error) {
          state.error = error.message || 'Il y a eu une erreur'
        }

        state.info = ''
        state.loading = false
      }
      
      return {
        ...toRefs(state),
        submit,
      }
    },
  }
</script>